import { render, staticRenderFns } from "./HistoryList.vue?vue&type=template&id=318a6871&scoped=true&"
import script from "./HistoryList.vue?vue&type=script&lang=js&"
export * from "./HistoryList.vue?vue&type=script&lang=js&"
import style0 from "./HistoryList.vue?vue&type=style&index=0&id=318a6871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a6871",
  null
  
)

export default component.exports